export const description =
  "Aides locales pour exploitations agricoles : Conseils régionaux et départementaux, EPCI, Agences de l'eau (économies d'irrigation), MSA prévention. Cumul possible avec CEE et PCAE.";
